export const SET_LIST = 'statistics1/SET_LIST'
export const SET_TOTAL = 'statistics1/SET_TOTAL'
export const SET_CURRENT = 'statistics1/SET_CURRENT'
export const SET_INPUT_VALUE = 'statistics1/SET_INPUT_VALUE'